import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

console.log(navigator.language);


var chosen = localStorage.getItem('choose_lang');
var current_locale;


if (chosen != null){


 chosen = localStorage.getItem('choose_lang')
 console.log(chosen)
  current_locale = chosen
}
else {
  console.log(navigator.language);
   current_locale = "en"
 
if (navigator.language.includes("it")){
  current_locale = "it"
}
}





const i18n = new VueI18n({
  locale: current_locale,
  messages: {
    en: require('./en-US.json'),
    it: require('./it-IT.json')
  }
})

if (module.hot) {
  module.hot.accept(['./en-US.json', './it-IT.json'], () => {
    i18n.setLocaleMessage('en', require('./en-US.json'))
    i18n.setLocaleMessage('it', require('./it-IT.json'))
    console.log('hot reload', this, arguments)
    console.log("Current lang is: "+navigator.language)
  })
}

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js